import { render } from "./businessType.vue?vue&type=template&id=1fe227e8"
import script from "./businessType.vue?vue&type=script&lang=js"
export * from "./businessType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__